export default "__VITE_ASSET__DbWp2sxz__"